import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useFormContext } from 'react-hook-form';

import { StyleButton, StyleRawTypography, StyleTextField } from '../style';

import { IQuiz } from '@interfaces/learning';
import { sanitize } from 'src/helpers/utils';
import theme from 'src/theme';

export type EssayFormProps = {
  content: IQuiz;
};

export type InteractiveEssayFields = {
  answer: string;
};

const EssayForm = ({ content }: EssayFormProps) => {
  const { name } = content;
  const questionSet = content.question_sets?.[0];
  const question = questionSet?.question_sets_questions?.[0]?.content;

  const { t } = useTranslation();

  const {
    register,
    formState: { isDirty, isSubmitting },
  } = useFormContext<InteractiveEssayFields>();

  return (
    <>
      <Box display="flex" flexDirection="column">
        <Typography fontWeight={500} fontSize={18} color={theme.palette.text.secondary}>
          {t('interactive.essay_form.rule')}
        </Typography>

        <StyleRawTypography
          fontSize={24}
          fontWeight={500}
          mb={3}
          dangerouslySetInnerHTML={sanitize(question?.name || '')}
        />

        <StyleTextField
          placeholder={t('interactive.essay_form.question.placeholder')}
          multiline
          inputProps={register('answer')}
          fontSize={18}
          fontFamily="Lanna"
        />
      </Box>
      <Box
        alignSelf={{
          xs: 'stretch',
          md: 'flex-end',
        }}
        mt={3}
      >
        <StyleButton
          variant="contained"
          type="submit"
          disabled={!isDirty || isSubmitting}
          sx={{
            [theme.breakpoints.down('md')]: {
              width: '100%',
            },
          }}
        >
          {isSubmitting && <CircularProgress size={24} sx={{ mr: 1.5 }} />}
          {t('interactive.essay_form.button.submit')}
        </StyleButton>
      </Box>
    </>
  );
};

export default EssayForm;
